import { ID_DOMINIO_COMUNI } from 'civil-status/pages/research-municipality';
import { MunicipalityFormVM } from 'civil-status/view-models/municipality-form';
import { ValueDomainType } from 'shell/models/value-domain-type';

export const transformerMunicipalityToSave = (data: MunicipalityFormVM): ValueDomainType => {
  return {
    key: {
      codEnte: data.institution || undefined,
      idDominio: ID_DOMINIO_COMUNI,
      idValore: data.id || undefined,
    },
    idValoreAnsc: data.anscMunicipality?.code?.toString() || undefined,
    dataInizioValidita: data.dateFrom ? data.dateFrom.toFormat('yyyy-MM-dd') : undefined,
    dataFineValidita: data.dateTo ? data.dateTo.toFormat('yyyy-MM-dd') : undefined,
    numOrdinamento: data.order || undefined,
    valore: data.description || undefined,
    descrizioneBreveValore: data.description || undefined,
    note: data.note || undefined,
  };
};
